import { ErrorInterface } from '../../interfaces/general.interface';
import { AuthUserEntityInterface } from '../../interfaces/auth.interface';

export interface LoginCodeState {
  error: boolean | ErrorInterface;
  loading: boolean;
  response: null | AuthUserEntityInterface;
}

export const initialLoginCodeState: LoginCodeState = {
  error: false,
  loading: false,
  response: null,
};
